import {Component, Input} from '@angular/core';
import {Host, MenuItem} from "../../../../common";

@Component({
  selector: 'menu-item-preview',
  standalone: false,
  template: `
      <div [routerLink]="['/item', item.id]" class="card is-clickable mb-3 item-entry">
        <img class="card-img-top" [src]="item.image" *ngIf="item.image" alt="{{ item.name }}">
        <div class="card-body">
          <div class="d-flex flex-column">
            <div><b>{{ item.name }}</b></div>
            <div class="text-sm-right mt-1 mt-sm-0 text-right">
              <div *ngIf="!item.hasVariants()"><b>{{ item.price|currency:host }}</b></div>
              <div *ngFor="let variant of item.variants">
                {{ variant.name }} <b>{{ variant.price|currency:host }}</b>
              </div>
            </div>
          </div>
          <div class="card-text mt-1" *ngIf="item.text" [innerHTML]="item.text"></div>
        </div>
      </div>
`
})
export class MenuItemPreviewComponent {
  @Input() host: Host;
  @Input() item: MenuItem;
}
